<div class="content" [ngClass]="{ divMargin: isUserProvider }">
  <div class="row-buttons">
    <button
      class="button-export"
      id="second-button-export"
      (click)="exportToExcel(tableData, 'nível-serviço')"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.053 3.68361H12.6706V2.17969L2.17969 3.79891V17.992L12.6706 19.7989V17.5698H19.053C19.2463 17.5796 19.4356 17.5125 19.5795 17.3831C19.7234 17.2537 19.8102 17.0725 19.821 16.8793V4.37351C19.8101 4.18038 19.7232 3.99941 19.5793 3.87014C19.4354 3.74087 19.2462 3.67381 19.053 3.68361ZM19.1538 16.994H12.6492L12.6385 15.8038H14.2054V14.4177H12.6265L12.6189 13.5986H14.2054V12.2125H12.607L12.5994 11.3935H14.2054V10.0074H12.5944V9.18832H14.2054V7.80222H12.5944V6.98316H14.2054V5.59706H12.5944V4.33697H19.1538V16.994Z"
          fill="white"
        />
        <path
          d="M15.0879 5.59375H17.8116V6.97985H15.0879V5.59375ZM15.0879 7.79954H17.8116V9.18565H15.0879V7.79954ZM15.0879 10.0053H17.8116V11.3914H15.0879V10.0053ZM15.0879 12.2111H17.8116V13.5972H15.0879V12.2111ZM15.0879 14.4169H17.8116V15.803H15.0879V14.4169Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.91866 7.6342L6.27074 7.55671L7.12068 9.89355L8.12497 7.46031L9.47705 7.38281L7.83515 10.7006L9.47705 14.0267L8.04747 13.9303L7.08224 11.3949L6.11638 13.8339L4.80273 13.7179L6.32871 10.78L4.91866 7.6342Z"
          fill="#004877"
        />
      </svg>
      <p>Exportar</p>
    </button>
    <button class="button-clean" (click)="cleanFilters()">
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.68589 0.924805L3.45013 5.63466C3.50712 5.77428 3.58605 5.83846 3.69321 5.87856C3.8006 5.91876 3.94021 5.9205 4.06431 5.8845C4.18841 5.84849 4.2895 5.77452 4.33265 5.71269C4.37588 5.65081 4.38749 5.62306 4.3496 5.52951L4.34806 5.5256L2.62275 0.924805H1.68589ZM4.84615 5.12461L4.90924 5.29275L4.90622 5.28496C5.01851 5.56241 4.96757 5.873 4.82125 6.08267C4.67493 6.29227 4.45971 6.42294 4.22647 6.49061C3.99323 6.55832 3.73472 6.5628 3.48883 6.47069C3.24293 6.37861 3.01379 6.17541 2.89341 5.87911L2.89173 5.87499L2.83277 5.71768C1.78201 6.40997 1.40748 7.18678 1.64586 8.12585C1.68747 8.28948 1.7607 8.55806 1.84601 8.89944C4.34185 8.71508 6.54253 8.06496 8.55152 7.09568C8.20596 6.61093 7.79643 6.19275 7.26846 5.88862C6.58032 5.49221 5.66927 5.184 4.84619 5.12457L4.84615 5.12461ZM8.89202 7.62471C6.82819 8.63182 4.557 9.31585 1.99297 9.51923C2.06109 9.82276 2.12989 10.1582 2.19265 10.5153C5.19933 10.1628 7.66433 9.59875 9.50046 8.81058C9.30772 8.40089 9.1114 7.99994 8.89202 7.62471ZM9.76592 9.37814C7.84989 10.2091 5.33636 10.7795 2.29114 11.1372C2.59345 13.2793 2.55711 15.9126 0.824951 17.0748C1.37097 17.0748 1.89524 17.0695 2.39978 17.0591C2.99848 16.1658 3.44919 14.7442 3.47638 14.0477C3.75391 14.6347 3.58702 16.1213 3.29649 17.0342C3.38828 17.0309 3.47889 17.0274 3.56924 17.0238C3.96605 16.5904 3.96269 16.0229 4.06324 15.3709C4.17479 15.8925 4.29815 16.5233 4.38222 16.9844C4.76054 16.9628 5.12564 16.9375 5.47647 16.9081C6.02618 16.1964 6.20304 15.1741 6.10169 13.92C6.24351 14.9372 6.40762 16.0921 6.50015 16.8056C6.8244 16.7678 7.13526 16.7256 7.43334 16.6793C7.60248 16.0226 7.29575 14.9859 7.36381 14.2484C7.73709 15.7555 8.11041 16.1868 8.4837 16.4871C8.66559 16.4482 8.84128 16.407 9.01169 16.3639C8.85396 15.8762 9.06448 15.5775 9.05129 14.9661C9.24081 15.6299 9.54211 15.9085 9.87109 16.1133C10.0894 16.0398 10.296 15.9617 10.4917 15.8791C10.138 15.6495 10.1523 14.9572 10.0762 14.3786C10.276 15.1373 10.5599 15.5118 10.8844 15.7005C11.8618 15.2181 12.5185 14.5982 12.9114 13.8248C12.6067 13.6913 12.2847 13.3703 11.9694 13.1225C12.4129 13.3839 12.7642 13.4935 13.0557 13.5046C13.1001 13.3925 13.1401 13.2777 13.175 13.1596C11.2847 12.477 10.4878 10.9218 9.76595 9.37807L9.76592 9.37814Z"
          fill="#FFF"
        />
      </svg>
      <span>Limpar filtros</span>
    </button>
  </div>

  <form [formGroup]="form">
    <div class="form-group">
      <input
        type="date"
        class="form-input"
        id="startCompletionDate"
        name="startCompletionDate"
        formControlName="startCompletionDate"
        (change)="checkStartCompletionDate()"
        [max]="maxCompletionDate | date : 'yyyy-MM-dd'"
      />
      <label
        class="form-label"
        for="startCompletionDate"
        [ngClass]="{ focus: form.get('startCompletionDate')?.value }"
      >
        Período data inicial
      </label>
      <span
        class="alert"
        *ngIf="
          form.get('startCompletionDate')?.getError('required') &&
          (form.get('startCompletionDate')?.touched ||
            form.get('startCompletionDate')?.dirty)
        "
      >
        Campo Obrigatório
      </span>
      <span
        class="alert"
        *ngIf="
          form.get('startCompletionDate')?.getError('invalidDate') &&
          (form.get('startCompletionDate')?.touched ||
            form.get('startCompletionDate')?.dirty)
        "
      >
        Data Inválida
      </span>
    </div>
    <div class="form-group">
      <input
        type="date"
        class="form-input"
        id="endCompletionDate"
        name="endCompletionDate"
        formControlName="endCompletionDate"
        [min]="minCompletionDate | date : 'yyyy-MM-dd'"
        [max]="maxCompletionDate | date : 'yyyy-MM-dd'"
      />
      <label
        class="form-label"
        for="endCompletionDate"
        [ngClass]="{ focus: form.get('endCompletionDate')?.value }"
      >
        Período data final
      </label>
      <span
        class="alert"
        *ngIf="
          form.get('endCompletionDate')?.getError('required') &&
          (form.get('endCompletionDate')?.touched ||
            form.get('endCompletionDate')?.dirty)
        "
      >
        Campo Obrigatório
      </span>
      <span
        class="alert"
        *ngIf="
          form.get('endCompletionDate')?.getError('invalidDate') &&
          (form.get('endCompletionDate')?.touched ||
            form.get('endCompletionDate')?.dirty)
        "
      >
        Data Inválida
      </span>
    </div>
    <app-provider-select-filter
      #inputProvider
      [isUserProvider]="isUserProvider"
      (handleChangeProviderValue)="changeProviderValue($event)"
    ></app-provider-select-filter>
    <app-product-select-filter
      #inputProduct
      [isUserProvider]="isUserProvider"
      (handleChangeProductValue)="changeProductValue($event)"
    ></app-product-select-filter>
    <button
      type="button"
      class="button"
      style="height: 36px; margin-top: 8px; padding: 0 8px; font-size: 16px"
      (click)="submitForm()"
    >
      Pesquisar
    </button>
  </form>
  <div class="table-area" [ngStyle]="{ display: true ? 'inherit' : 'none' }">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="receiptDate">
        <th mat-header-cell *matHeaderCellDef>Data de Recebimento</th>
        <td mat-cell *matCellDef="let element">
          {{ element.receivements.dataRecebimento | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cd">
        <th mat-header-cell *matHeaderCellDef>Local de Entrega</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.receivements?.documentoCliente
              ? element.receivements?.documentoCliente + " - "
              : "-"
          }}
          {{
            element.receivements?.nomeCliente
              ? element.receivements?.nomeCliente
              : ""
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="providerName">
        <th mat-header-cell *matHeaderCellDef>Nome do Fornecedor</th>
        <td mat-cell *matCellDef="let element">
          {{ element.receivements?.nomeFantasiaFornecedor || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th mat-header-cell *matHeaderCellDef>CNPJ/CPF</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.receivements?.documentoFornecedor
              ? element.receivements.documentoFornecedor
              : "-"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Nome e Código do Produto</th>
        <td mat-cell *matCellDef="let element">
          {{ element.receivements.product.name }}
          {{
            element.receivements.product.code
              ? "-" + element.receivements.product.code
              : ""
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="plu">
        <th mat-header-cell *matHeaderCellDef>PLU</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.receivements.product.plu
              ? element.receivements.product.plu
              : "-"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef>Nº Nota Fiscal</th>
        <td mat-cell *matCellDef="let element">
          {{ element.receivements?.nf_fornecedor || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amountOrdered">
        <th mat-header-cell *matHeaderCellDef>Quantidade Solicitada</th>
        <td mat-cell *matCellDef="let element">
          {{ element.receivements?.quantidadeSolicitada || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amountDelivered">
        <th mat-header-cell *matHeaderCellDef>Quantidade Entregue</th>
        <td mat-cell *matCellDef="let element" style="white-space: nowrap">
          {{
            element.receivements?.quantidadeRecebida +
              element.receivements?.quantidadeDevolvida
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status da Qualidade</th>
        <td mat-cell *matCellDef="let element">
          {{
            element.receivements?.parecer
              ? element.receivements.parecer
              : "SEM INFORMAÇÃO"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="efficiency">
        <th mat-header-cell *matHeaderCellDef>
          Nível de Eficiência de Serviço (%)
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            (element.receivements?.percentualQualidade * 100
              | number : "1.2-2" : "pt-BR") || "-"
          }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="10">Nenhum registro encontrado</td>
      </tr>
    </table>
  </div>
  <div class="paginacao">
    <mat-paginator
      id="paginator"
      [pageSizeOptions]="[5, 10, 25]"
      [length]="length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      showFirstLastButtons
      (page)="paginate($event)"
      [ngStyle]="{ display: true ? 'inherit' : 'none' }"
    ></mat-paginator>
  </div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
